import styled from 'styled-components';
import colors from '../../common/theme/colors';
import { spacing } from '../../common/theme/constants';

export const KitCounter = styled.span`
  background-color: ${colors.gray_30};
  border-radius: 100%;
  width: 1.3125rem;
`;

export const KitLabelText = styled.span`
  margin: 0 ${spacing.absolute.xs}px;
`;
